<div class="dialog-padding">
  <h1 mat-dialog-title>
    <ng-container *ngIf="data.svgIcon">
      <mat-icon [svgIcon]="data.svgIcon" [class]="data.svgClass"></mat-icon>
    </ng-container>
    <span id="confirmationDialog-text-title">{{ data.title }}</span>
  </h1>
  <p id="confirmationDialog-text-message" mat-dialog-content [innerHTML]="data.message" data-private></p>
  <div mat-dialog-actions align="end">
    <afp-button *ngIf="data.showDismissButton" id="confirmationDialog-button-cancel" variant="clear" (click)="onNoClick()">
      {{ data.dismissText }}
    </afp-button>
    <afp-button
      id="confirmationDialog-button-confirm"
      mat-raised-button
      [variant]="buttonVariant"
      uzDebounceClick
      [debounceTime]="500"
      (debounceClick)="confirm()"
    >
      {{ data.confirmText }}
    </afp-button>
  </div>
</div>
